import { Box, Stack, Skeleton } from "@mui/material";

// CSS
import "./ReportSkeleton.css";

interface propsType {}

const ReportSkeleton = (props: propsType) => {
  return (
    <>
      <section id="commWrap" className="report-list">
        <article className="article-01">
          <div className="article-tit ta-c ">
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Skeleton variant="rounded" width={400} height={40} />
            </Box>
          </div>
        </article>
        <Box>
          <Stack direction={"column"} spacing={0}>
            <Stack direction={"column"} spacing={0} sx={{ width: "100%" }}>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Skeleton variant="rounded" width={"100%"} height={40} />
              </Box>
              <Box sx={{ display: "flex", justifyContent: "flex-start", pt: "49px" }}>
                <Skeleton variant="rounded" width={116} height={21} />
              </Box>
              <Box sx={{ display: "flex", justifyContent: "flex-start", pt: "8px" }}>
                <Skeleton variant="rounded" width={"100%"} height={52} />
              </Box>
              <Box sx={{ display: "flex", justifyContent: "flex-start", pt: "8px" }}>
                <Skeleton variant="rounded" width={"100%"} height={52} />
              </Box>
              <Box sx={{ pt: "57px" }}>
                <Stack direction={"row"} spacing={2}>
                  <Skeleton variant="rounded" width={"100%"} height={163} />
                  <Skeleton variant="rounded" width={"100%"} height={163} />
                  <Skeleton variant="rounded" width={"100%"} height={163} />
                </Stack>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "flex-start", pt: "90px" }}>
                <Skeleton variant="rounded" width={"100%"} height={52} />
              </Box>
              <Box sx={{ display: "flex", justifyContent: "flex-start", pt: "8px" }}>
                <Skeleton variant="rounded" width={"100%"} height={52} />
              </Box>
              <Box sx={{ display: "flex", justifyContent: "flex-start", pt: "8px" }}>
                <Skeleton variant="rounded" width={"100%"} height={52} />
              </Box>
            </Stack>
          </Stack>
        </Box>
      </section>
    </>
  );
};

export default ReportSkeleton;
